import { GUI } from "three/addons/libs/lil-gui.module.min.js";
import { resources } from "./blocks";
export function setupUI(world, player, physics) {
	const gui = new GUI();

	const playerFolder = gui.addFolder("Player");

	playerFolder.add(player, "maxSpeed", 1, 20).name("Max Speed");
	playerFolder.add(player, "jumpSpeed", 1, 10, 0.1).name("Jump Speed");
	playerFolder.add(player.boundsHelper, "visible").name("Show Player Bounds");
	playerFolder.add(player.cameraHelper, "visible").name("Show Camera helper");
	gui.add(world.size, "width", 8, 128, 1).name("Width");
	gui.add(world.size, "height", 8, 64, 1).name("Height");
	const physicsFolder = gui.addFolder("Physics");

	physicsFolder.add(physics.helpers, "visible").name("Visualize Collisions");
	physicsFolder.add(physics, "simulationRate", 10, 1000).name("Sim Rate");

	const terrainFolder = gui.addFolder("Terrain");

	terrainFolder.add(world.params, "seed", 0, 10000).name("Seed");
	terrainFolder.add(world.params.terrain, "scale", 10, 100).name("Scale");
	terrainFolder.add(world.params.terrain, "magnitude", 0, 1).name("Magnitude");
	terrainFolder.add(world.params.terrain, "offset", 0, 1).name("Offset");

	const resourcesFolder = gui.addFolder("Resources");
	for (const resource of resources) {
		const resourceFolder = resourcesFolder.addFolder(resource.name);
		resourceFolder.add(resource, "scarcity", 0, 1).name("Scarcity");
		const scaleFolder = resourceFolder.addFolder("Scale").close();
		scaleFolder.add(resource.scale, "x", 10, 100).name("X Scale");
		scaleFolder.add(resource.scale, "y", 10, 100).name("Y Scale");
		scaleFolder.add(resource.scale, "z", 10, 100).name("Z Scale");
	}

	gui.onChange(() => {
		world.generate();
	});
}
